import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

const columns = [
  { field: "Description", label: "ATD NO" },
  { field: "DEBIT", label: "Dr Amount" },
  { field: "CREDIT", label: "Cr Amount" },
  
];


const parseAmount = (value) => {
  if (value == null) return 0;

  let str = String(value).replace(/,/g, "").trim();

  // Handle trailing minus
  if (str.endsWith("-")) {
    str = "-" + str.slice(0, -1);
  }

  return Number(str) || 0;
};


export default function WGRTable({
  rows,
  shop,
  totals,
  showTotal = true,
}) {
  return (
    <TableContainer>
      <Table
        size="small"
       stickyHeader
      >
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.field}
                align="right"
                sx={{
                  fontWeight: 700,
                  bgcolor: "grey.200",
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>




        </TableHead>

        <TableBody>
          {rows.map((row, index) => {
           
            return (
              <TableRow
                key={index}
                hover
                sx={{
                  "&:nth-of-type(even)": {
                    bgcolor: "grey.50",
                  },
                }}
              >
                <TableCell colSpan={1} align="right">{row.Description}</TableCell>

                <TableCell align="right">
                  <CurrencyCell value={row.DEBIT} />
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell value={row.CREDIT} />
                </TableCell>
              </TableRow>



            );
          })}






          {showTotal && (
            <>
            <TableRow
              sx={{
                bgcolor: "primary.light",
                "& td": {
                  fontWeight: 700,
                  borderTop: "2px solid",
                  borderColor: "primary.main",
                },
              }}
            >
              <TableCell colSpan={1} align="right">
                Total Amount
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={totals.debit} />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={totals.credit} />
              </TableCell>

              </TableRow>

 <TableRow
              sx={{
                bgcolor: "#fff",
                "& td": {
                  fontWeight: 700,
                  borderTop: "2px solid",
                  borderColor: "primary.main",
                  height:100,
                },
              }}
            >
              <TableCell colSpan={2} align="right">
                Net Amount (Dr-Cr)
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={Number(totals.debit)-Number(totals.credit)} />
              </TableCell>

             

              </TableRow>

 </>


              
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}